(() => {
  function init(root) {
    if (root.dataset.ready) return;
    let product;
    try { product = JSON.parse(root.querySelector('[data-product-json]').textContent); } catch { return; }
    if (!product?.variants?.length) return;
    root.dataset.ready = 'true';
    const forms = [...root.querySelectorAll('[data-buy-form]')];
    const selected = { bra_size: '', bottom_size: '' };
    const buyDialog = root.querySelector('[data-buy-dialog]');
    const sizeDialog = root.querySelector('[data-size-dialog]');
    const imageDialog = root.querySelector('[data-image-dialog]');
    const dialogs = [buyDialog, sizeDialog, imageDialog].filter(Boolean);
    const nativeSize = document.querySelector('[data-jd-native-size] #naked-size-popup');
    const nativeSizeVisible = () => !!nativeSize && getComputedStyle(nativeSize).display !== 'none';
    const openers = new WeakMap();
    const currency = window.Shopify?.currency?.active || 'USD';
    const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency, maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    const current = () => product.variants.find(v => v.option1 === selected.bra_size && v.option2 === selected.bottom_size);
    let busy = false;
    function analytics(name, extra = {}) {
      try {
        if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
        const data = { creative: '434', page_type: 'dtc-everyday', ...extra };
        window.Shopify.analytics?.publish?.(name, data);
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...data });
      } catch { /* Purchase and browsing remain independent of optional analytics. */ }
    }
    function setError(form, message) {
      const error = form.querySelector('[data-error]');
      error.textContent = message;
      error.hidden = false;
    }
    function update() {
      const variant = current();
      root.querySelectorAll('[data-product-price]').forEach(el => { el.textContent = money(variant?.price ?? product.price); });
      forms.forEach(form => {
        form.querySelectorAll('input[type="radio"]').forEach(input => {
          input.checked = selected[input.name] === input.value;
          input.disabled = busy || (input.name === 'bottom_size' && !!selected.bra_size && !product.variants.some(v => v.option1 === selected.bra_size && v.option2 === input.value && v.available));
        });
        form.querySelector('[name="id"]').value = variant?.available ? variant.id : '';
        const button = form.querySelector('[data-lp-add]');
        button.disabled = busy;
        const text = busy ? 'ADDING TO YOUR BAG…' : variant?.available ? `ADD TO BAG · ${money(variant.price)}` : 'CHOOSE YOUR SIZES';
        button.replaceChildren(document.createTextNode(text));
        if (!busy) {
          const arrow = document.createElement('span');
          arrow.setAttribute('aria-hidden', 'true'); arrow.textContent = '↗'; button.append(arrow);
        }
        form.querySelector('[data-status]').textContent = variant
          ? variant.available ? `Your choice: bra ${variant.option1} / bottom ${variant.option2}.` : 'This size combination is unavailable. Choose another size.'
          : 'Choose your top and bottom sizes separately.';
      });
    }
    function setDialogState() {
      document.documentElement.classList.toggle('jd-dialog-open', dialogs.some(d => d.open) || nativeSizeVisible());
      refreshSticky();
    }
    function openDialog(dialog, button) {
      if (!dialog?.showModal) { root.querySelector('#jd-buy')?.scrollIntoView({ block: 'start' }); return; }
      openers.set(dialog, button);
      dialog.showModal();
      setDialogState();
    }
    dialogs.forEach(dialog => {
      dialog.querySelector('[data-close-dialog]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        setDialogState();
        const opener = openers.get(dialog);
        if (opener?.isConnected) opener.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', e => {
        if (e.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
      });
    });
    root.querySelectorAll('[data-open-buy]').forEach(button => button.addEventListener('click', () => {
      openDialog(buyDialog, button);
      analytics('lp_shop_open', { placement: button.dataset.placement || 'body' });
    }));
    let sizeOpener, returnToBuy = false, nativeWasOpen = false;
    const localizeSizeAge = () => {
      const label = nativeSize?.querySelector('#naked-size-age-value .naked-size-primary-unit');
      if (label && label.textContent !== 'years') label.textContent = 'years';
    };
    const setNativeUnits = unit => {
      const finder = window.nakedSizeRecommender;
      if (!finder || !nativeSize) return;
      if (finder.currentUnit !== unit) {
        finder.currentUnit = unit;
        if (finder.isMobile) { finder.updateSliderUnit('height', unit); finder.updateSliderUnit('weight', unit); }
        else finder.convertMeasurements();
      }
      nativeSize.querySelectorAll('[data-unit]').forEach(el => el.classList.toggle('active', unit === 'imperial' ? ['feet', 'lbs'].includes(el.dataset.unit) : ['cm', 'kg'].includes(el.dataset.unit)));
      localizeSizeAge();
    };
    root.querySelectorAll('[data-size-help]').forEach(button => button.addEventListener('click', () => {
      if (!nativeSize || !window.nakedSizeRecommender) { openDialog(sizeDialog, button); return; }
      returnToBuy = buyDialog.open;
      sizeOpener = returnToBuy ? openers.get(buyDialog) : button;
      dialogs.forEach(d => { if (d.open) d.close(); });
      document.getElementById('naked-size-button').click();
      if (!nativeSize.dataset.jdLocalized) {
        ['bra-size-system', 'bottom-size-system'].forEach(id => {
          const select = nativeSize.querySelector('#' + id);
          if (select) { select.value = 'US'; select.dispatchEvent(new Event('change', { bubbles: true })); }
        });
        setNativeUnits('imperial');
        nativeSize.dataset.jdLocalized = 'true';
      }
      localizeSizeAge();
      nativeSize.setAttribute('role', 'dialog'); nativeSize.setAttribute('aria-modal', 'true');
      nativeSize.setAttribute('aria-label', 'Find your JOLYE size');
      setTimeout(() => nativeSize.querySelector('.naked-size-close-btn, .naked-size-close')?.focus(), 120);
      analytics('lp_size_help_open');
    }));
    const nativeSizeObserver = nativeSize ? new MutationObserver(() => {
      const visible = nativeSizeVisible();
      setDialogState();
      if (!visible && nativeWasOpen) {
        if (returnToBuy) { returnToBuy = false; openDialog(buyDialog, sizeOpener); }
        else sizeOpener?.focus({ preventScroll: true });
      }
      nativeWasOpen = visible;
    }) : null;
    nativeSizeObserver?.observe(nativeSize, { attributes: true, attributeFilter: ['style', 'class'] });
    nativeSize?.addEventListener('input', localizeSizeAge);
    nativeSize?.addEventListener('click', e => {
      const unitButton = e.target.closest('[data-unit]');
      if (unitButton) { e.preventDefault(); e.stopImmediatePropagation(); setNativeUnits(['cm', 'kg'].includes(unitButton.dataset.unit) ? 'metric' : 'imperial'); return; }
      if (e.target.closest('.naked-size-close, .naked-size-close-btn')) window.nakedSizeRecommender?.closePopup();
      if (!e.target.closest('#step7-apply')) return;
      const bra = nativeSize.querySelector('#naked-size-top-size')?.textContent.trim();
      const bottom = nativeSize.querySelector('#naked-size-bottom-size')?.textContent.trim();
      if (product.variants.some(v => v.option1 === bra && v.option2 === bottom && v.available)) {
        selected.bra_size = bra; selected.bottom_size = bottom;
        forms.forEach(f => { f.querySelector('[data-error]').hidden = true; f.querySelector('[data-success]').hidden = true; });
        update(); analytics('lp_size_apply');
      }
    }, true);
    const nativeSizeKeydown = e => {
      if (!nativeSizeVisible()) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); window.nakedSizeRecommender?.closePopup(); }
      if (e.key === 'Tab') {
        const items = [...nativeSize.querySelectorAll('button, input, select, [tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        const first = items[0], last = items.at(-1);
        if (e.shiftKey && (document.activeElement === first || !nativeSize.contains(document.activeElement))) { e.preventDefault(); last?.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || !nativeSize.contains(document.activeElement))) { e.preventDefault(); first?.focus(); }
      }
    };
    document.addEventListener('keydown', nativeSizeKeydown, true);
    if (imageDialog) {
      const enlarged = imageDialog.querySelector('[data-enlarged-image]');
      const stage = imageDialog.querySelector('[data-image-stage]');
      const zoom = imageDialog.querySelector('[data-image-zoom]');
      let photoRequest = 0;
      root.querySelectorAll('.jd-hero-media img, [data-angle-main], .jd-angle-secondary img, [data-look-image], .jd-detail-grid img, [data-buy-gallery]').forEach(photo => {
        photo.dataset.zoomable = 'true'; photo.tabIndex = 0; photo.setAttribute('role', 'button');
        photo.setAttribute('aria-haspopup', 'dialog'); photo.setAttribute('aria-label', 'Enlarge photo: ' + photo.alt);
        const showPhoto = () => {
          const request = ++photoRequest;
          enlarged.src = photo.complete && photo.naturalWidth ? photo.currentSrc || photo.src : photo.src; enlarged.alt = photo.alt;
          const url = new URL(photo.src, location.href); url.searchParams.delete('width');
          const detailed = new Image();
          detailed.onload = () => { if (request === photoRequest) enlarged.src = detailed.src; };
          detailed.src = url.href;
          stage.classList.remove('is-magnified'); zoom.textContent = 'Zoom in +'; zoom.setAttribute('aria-pressed', 'false');
          openDialog(imageDialog, photo); stage.scrollTo(0, 0);
        };
        photo.addEventListener('click', showPhoto);
        photo.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showPhoto(); } });
      });
      zoom.addEventListener('click', () => {
        const magnified = stage.classList.toggle('is-magnified');
        zoom.textContent = magnified ? 'Fit to screen −' : 'Zoom in +'; zoom.setAttribute('aria-pressed', String(magnified)); stage.scrollTo(0, 0);
      });
    }
    forms.forEach(form => {
      // The store's cart app listens for submit-button clicks. Validation stays in this form.
      form.querySelector('[data-lp-add]').addEventListener('click', () => form.requestSubmit());
      form.addEventListener('change', e => {
        if (!(e.target.name in selected)) return;
        selected[e.target.name] = e.target.value;
        if (selected.bra_size && selected.bottom_size && !product.variants.some(v => v.option1 === selected.bra_size && v.option2 === selected.bottom_size && v.available)) selected.bottom_size = '';
        forms.forEach(f => { f.querySelector('[data-error]').hidden = true; f.querySelector('[data-success]').hidden = true; });
        update();
      });
      form.addEventListener('submit', async e => {
        e.preventDefault(); e.stopImmediatePropagation();
        if (busy) return;
        const variant = current();
        form.querySelector('[data-error]').hidden = true;
        form.querySelector('[data-success]').hidden = true;
        if (!variant?.available) {
          setError(form, 'Choose both your bra size and your bottom size to add your set.');
          form.querySelector(`input[name="${!selected.bra_size ? 'bra_size' : 'bottom_size'}"]:not(:disabled)`)?.focus();
          return;
        }
        busy = true; update();
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 18000);
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }), signal: controller.signal
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'We couldn’t add your set. Please try again.');
          forms.forEach(f => {
            f.querySelector('[data-added-text]').textContent = `In your bag: JOLYE Black, bra ${variant.option1}, bottom ${variant.option2}.`;
            f.querySelector('[data-success]').hidden = false;
          });
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          analytics('lp_add_to_cart', { variant_id: variant.id, value: variant.price / 100, currency });
          const handoff = () => {
            const cart = document.querySelector('#corner-cowi-open-primary-card, naked-cart[open] .nkc-panel');
            if (cart && Number(getComputedStyle(cart).opacity) > .5 && getComputedStyle(cart).pointerEvents !== 'none') {
              dialogs.forEach(d => { if (d.open) d.close(); });
            }
          };
          handoff(); [200, 500, 1000].forEach(ms => setTimeout(handoff, ms));
        } catch (error) {
          setError(form, ['AbortError', 'TypeError'].includes(error.name) ? 'We couldn’t confirm the update. Check your bag before trying again.' : error.message || 'We couldn’t add your set. Please try again.');
        } finally { clearTimeout(timer); busy = false; update(); }
      }, true);
    });
    root.querySelectorAll('[data-angle]').forEach(button => button.addEventListener('click', () => {
      const image = root.querySelector('[data-angle-main]');
      image.src = image.dataset[button.dataset.angle];
      image.alt = `JOLYE Black four-piece set, ${button.dataset.angle} view`;
      root.querySelector('[data-angle-caption]').textContent = `JOLYE BLACK / ${button.dataset.angle.toUpperCase()} VIEW`;
      root.querySelectorAll('[data-angle]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      const secondary = root.querySelector('[data-angle-secondary]');
      if (secondary) {
        const other = button.dataset.angle === 'back' ? 'front' : 'back';
        secondary.src = secondary.dataset[other]; secondary.alt = `JOLYE Black four-piece set, ${other} view`;
        secondary.setAttribute('aria-label', 'Enlarge photo: ' + secondary.alt);
        root.querySelector('[data-secondary-caption]').textContent = `JOLYE BLACK / ${other.toUpperCase()} VIEW`;
      }
      image.setAttribute('aria-label', 'Enlarge photo: ' + image.alt);
      analytics('lp_product_view', { view: button.dataset.angle });
    }));
    root.querySelectorAll('[data-look]').forEach(button => button.addEventListener('click', () => {
      const image = root.querySelector('[data-look-image]');
      image.src = button.dataset.src;
      const everyday = button.dataset.look === 'everyday';
      image.alt = everyday ? 'Everyday styling: JOLYE underneath a gray hoodie' : 'The complete JOLYE look with bra, bottom, garter belt and thigh bands';
      image.setAttribute('aria-label', 'Enlarge photo: ' + image.alt);
      root.querySelector('[data-look-caption]').textContent = everyday ? 'BRA + BOTTOM. HOODIE ON.' : 'ALL FOUR PIECES. ALL YOURS.';
      root.querySelectorAll('[data-look]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      if (innerWidth <= 760) image.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      analytics('lp_style_select', { look: button.dataset.look });
    }));
    root.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
      const image = root.querySelector('[data-buy-gallery]');
      image.src = button.dataset.gallerySrc; image.alt = button.dataset.alt; image.setAttribute('aria-label', 'Enlarge photo: ' + image.alt);
      root.querySelectorAll('[data-gallery-src]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
    const sticky = root.querySelector('[data-sticky]');
    const hero = root.querySelector('.jd-hero-commerce');
    const end = root.querySelector('[data-lp-end]');
    let pendingScroll = false;
    function refreshSticky() {
      pendingScroll = false;
      const visibleForm = [...root.querySelectorAll('[data-inline-buy]')].some(el => {
        const r = el.getBoundingClientRect();
        return r.height > 0 && r.top < innerHeight - 90 && r.bottom > 130;
      });
      const h = hero.getBoundingClientRect();
      const show = h.bottom < 0 && end.getBoundingClientRect().top > innerHeight - 50 && !visibleForm && !dialogs.some(d => d.open) && !nativeSizeVisible();
      sticky.classList.toggle('is-visible', show); sticky.inert = !show; sticky.setAttribute('aria-hidden', String(!show));
    }
    const scheduleSticky = () => { if (!pendingScroll) { pendingScroll = true; requestAnimationFrame(refreshSticky); } };
    addEventListener('scroll', scheduleSticky, { passive: true }); addEventListener('resize', scheduleSticky);
    const params = new URLSearchParams(location.search);
    root.querySelectorAll('a[data-attribution]').forEach(a => {
      const url = new URL(a.href, location.href);
      for (const [key, value] of params) if (key.startsWith('utm_') || ['fbclid', 'gclid', 'ttclid', 'tw_source', 'tw_adid'].includes(key)) url.searchParams.set(key, value);
      url.searchParams.set('country', 'US'); url.searchParams.set('currency', 'USD');
      url.searchParams.set('lp_creative', '434'); url.searchParams.set('lp_variant', 'dtc-everyday');
      a.href = url.href;
    });
    // Suppress the legacy EUR acquisition popup only while this US landing is present.
    let popupObserver;
    const closeLegacyPopup = () => {
      const popup = document.querySelector('[role="dialog"]:has(.klaviyo-form)');
      const close = popup?.querySelector('button[aria-label="Close dialog"]');
      if (close && !popup.dataset.jdDismissed) { popup.dataset.jdDismissed = 'true'; popupObserver?.disconnect(); close.click(); }
    };
    popupObserver = new MutationObserver(closeLegacyPopup); popupObserver.observe(document.body, { childList: true, subtree: true }); closeLegacyPopup();
    update(); refreshSticky();
    root.addEventListener('shopify:section:unload', () => { popupObserver.disconnect(); nativeSizeObserver?.disconnect(); document.removeEventListener('keydown', nativeSizeKeydown, true); removeEventListener('scroll', scheduleSticky); removeEventListener('resize', scheduleSticky); document.documentElement.classList.remove('jd-dialog-open'); }, { once: true });
  }
  document.querySelectorAll('.jolye-dtc').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.jolye-dtc').forEach(init));
})();
